import React, { memo, useEffect } from 'react';

import log from 'loglevel';

import sprite from './assets/svg/sprite.svg?raw';

// Runtime sprite injection for client-rendered surfaces (webapp SPA, Storybook)
// whose HTML shell can't inline the sprite at build time. SSG surfaces (the
// landing page) inline the sprite directly in their layout instead.
export const SvgSpriteLoader: React.FC = memo(() => {
  useEffect(() => {
    if (!document.getElementById('svg-sprite')) {
      const div = document.createElement('div');
      div.id = 'svg-sprite';

      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sprite, 'image/svg+xml');

        const svgElement = doc.documentElement;
        if (svgElement && svgElement.tagName.toLowerCase() === 'svg') {
          div.appendChild(svgElement.cloneNode(true));
        } else {
          log.error('Invalid SVG content detected');
          return;
        }
      } catch (error) {
        log.error('Failed to parse SVG sprite:', error);
        return;
      }
      div.style.visibility = 'hidden';
      div.style.position = 'absolute';
      div.style.top = '0';
      div.style.left = '0';
      div.style.width = '0';
      div.style.height = '0';
      div.style.overflow = 'hidden';
      div.style.pointerEvents = 'none';
      document.body.appendChild(div);
    }
  }, []);

  return null;
});

SvgSpriteLoader.displayName = 'SvgSpriteLoader';
